import { render, staticRenderFns } from "./UserAgent.vue?vue&type=template&id=a24e2af4&"
import script from "./UserAgent.vue?vue&type=script&lang=js&"
export * from "./UserAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports